import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import GolfScoresTable from './GolfScoreTable';

const PlayerCard = ({ 
    events,
    player,
    teamLogo,
    playerScoreText,
    showScoresButton = false,
    intervalsToShow,
    findTournamentId,
    findTournamentInfo,
    useTeamLogo = false,
    alwaysShowScores = false,
}) => {
    //console.log("PLayer Scores", player);
    const imageUrl = useTeamLogo ? teamLogo : (player?.image || teamLogo);
    const playerName = `${player?.firstName} ${player?.lastName}`;
    const club = player?.club;
    // Go through each object in the scores an sum the scores
    const score = Object.values(player?.scores || {}).reduce((acc, eventScore) => {
      const val = eventScore?.score;
      return typeof val === 'number' ? acc + val : acc;
    }, 0);
  
    const formattedScore = score === 0 ? 'E' : score > 0 ? `+${score}` : score;
    const isPlayerCaptain = player?.captain || false;

    const [showScores, setShowScores] = useState(alwaysShowScores);

    const onShowScoresClick = () => {
        setShowScores(!showScores);
    };

    let playerScores = [];
    //console.log("Intervals To Show", intervalsToShow, "Events", events, "Player", player, "Show Scores Button", showScoresButton);
    if (events && player && showScores && intervalsToShow) {
        intervalsToShow?.forEach((interval) => {
            const tournamentId = findTournamentId(events, interval);
            const event = events?.find((event) => event.interval === interval);
            const tournamentInfo = findTournamentInfo(player, tournamentId);
            //console.log("Tournament Info", tournamentInfo, "Tournament ID", tournamentId, "Interval", interval);
            if (tournamentId) {
                playerScores.push({
                    eventName: event.name,
                    score: tournamentInfo?.score ?? tournamentInfo?.status ?? '-',
                    tied: tournamentInfo?.tied,
                    round1: tournamentInfo?.round1 || tournamentInfo?.status || '-',
                    round2: tournamentInfo?.round2 || tournamentInfo?.status || '-',
                    status: tournamentInfo?.status,
                    rank: tournamentInfo?.rank
                });
            }
        })
    }
    //console.log("Player Scores!!", playerScores);


  return (
    <>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        padding: 2,
        maxWidth: '375px',
        margin: '0 auto',
      }}>
        {/* Main content with image and text aligned */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: 1.5
        }}>
          {/* Player Image */}
          <Box sx={{ width: 75, height: 75, flexShrink: 0 }}>
            <img
              src={imageUrl}
              alt={`${playerName} profile`}
              style={{ 
                width: '75px', 
                height: '75px',
                objectFit: 'cover'
              }}
            />
          </Box>

          {/* Player Info - 3 lines of text only */}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {/* Row 1: Player Name and Role */}
            <Typography 
              variant="h5" 
              component="h2" 
              sx={{ 
                fontWeight: 'bold',
                fontSize: '20px',
                lineHeight: 1.2,
                textAlign: 'left',
              }}
            >
              {playerName} {isPlayerCaptain && `(C)`}
            </Typography>
            
            {/* Row 2: Club Name */}
            <Typography 
              variant="body1" 
              sx={{ 
                  color: 'text.primary',
                  fontSize: '1rem',
                  marginTop: 0.5,
                  textAlign: 'left',
              }}
            >
              {club}
            </Typography>
            
            {/* Row 3: Handicap and Event Type */}
            <Typography 
              variant="body1" 
              sx={{ 
                  color: 'text.primary',
                  fontSize: '1rem',
                  marginTop: 0.25,
                  textAlign: 'left',
              }}
            >
              {formattedScore && `(${formattedScore})`} 
              {playerScoreText && ` ${playerScoreText}`}
            </Typography>
          </Box>
        </Box>
        
        {/* Show Scores button positioned below the main content */}
        {showScoresButton && (
          <Box> 
            <Button
              variant="text"
              color="primary"
              endIcon={
                  <KeyboardArrowDownIcon 
                      sx={{ 
                        transform: showScores ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.1s'
                      }} 
                  />
              }
              onClick={onShowScoresClick}
              sx={{ 
                marginTop: 1,
                padding: '4px 0',
                color: '#3aaee0',
                textTransform: 'none',
                fontWeight: 'normal',
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }}
            >
              {showScores ? 'Hide Scores' : 'Show Scores'}
            </Button>
          </Box>
        )}
      </Box>

      {!showScoresButton && (
        <Box sx={{ height: '16px' }} />
      )}

      {/* Scores Section */}
      {showScores && (
          <GolfScoresTable scores={playerScores} team={false}/>
      )}
    </>
  );
};

export default PlayerCard;